import { useEffect, useState } from 'react';
import { type ServerClock, remainingMs } from './clock';

/** Milliseconds left until `deadline` on the server's clock, read at render (so a new deadline shows its own value at once) and re-read every `tickMs`. */
export function useCountdown(deadline: number | null, clock: ServerClock, tickMs = 250): number | null {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (deadline === null) return;
    const id = window.setInterval(() => setTick(t => t + 1), tickMs);
    return () => window.clearInterval(id);
  }, [deadline, tickMs]);
  return remainingMs(deadline, clock);
}
